var getCardTheme = theme => {
  var background = theme.colors.white;
  var boxShadow = "0 0 " + theme.space.s + " 0 rgba(0, 0, 0, 0.08)";
  return {
    colors: {
      background: {
        initial: background,
        hover: background
      },
      boxShadow: {
        initial: boxShadow,
        hover: boxShadow
      },
      border: {
        initial: theme.colors.greys[20]
      },
      foreground: {
        initial: "inherit",
        hover: theme.colors.ultraViolets["80"]
      }
    }
  };
};
export { getCardTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
